<template>
    <div class="Main" :style="{height: mainHeight + 'px'}">
      <el-container>
        <el-header style="height: 40px">
          <v-head></v-head>
        </el-header>
        <el-container>
          <el-aside :style="{ width: menuWidth + 'px' }" id="asideId">
            <v-side></v-side>
          </el-aside>
          <el-container :style="{height: containerHeight + 'px'}" id="mainId">
            <el-main>
              <el-tabs :value="getActiveTab" type="card" @tab-remove="removeTab" @tab-click="tabClick">
                <el-tab-pane v-for="(item) in cacheTabList"
                             :key="item.name"
                             :label="item.title"
                             :name="item.name"
                             :closable="item.closable"
                             :ref="item.ref" :style="{height: tabHeight + 'px'}">
                  <keep-alive :include="keepAliveLists">
                    <router-view :name="item.name"></router-view>
                  </keep-alive>
                </el-tab-pane>
              </el-tabs>
            </el-main>
<!--            <el-footer style="height: 25px">-->
<!--              <v-foot></v-foot>-->
<!--            </el-footer>-->
          </el-container>
        </el-container>
      </el-container>
    </div>
</template>

<script>
import vHead from './Header.vue'
import vSide from './Sidebar.vue'
import { mapMutations, mapGetters, mapState } from 'vuex'

export default {
  name: 'Main',
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters('cacheTabs', ['tabLists', 'keepAliveLists', 'getCurrentTab', 'getTabsPath', 'userHomePage']),
    ...mapState('cacheTabs', ['currentTab']),
    ...mapState('pageHeight', ['mainHeight', 'sideHeight', 'containerHeight', 'tabHeight', 'mtableHeight', 'dtableHeight', 'menuWidth']),
    cacheTabList () {
      let cacheList = [{
        title: this.$t('main.Home.Home'),
        name: this.userHomePage,
        closable: false,
        ref: 'tabs'
      }]
      cacheList = cacheList.concat(this.tabLists)
      return cacheList
    },
    getActiveTab () {
      return this.currentTab
    }
  },
  components: {
    vHead,
    vSide
  },
  watch: {
    $route: function (to) { // 监听路由的变化，动态生成tabs
      let flag = true // 判断是否需要新增页面
      const path = to.path
      const params = to.params
      if (Object.keys(to.meta).length !== 0) {
        for (let i = 0; i < this.$refs.tabs.length; i++) {
          // if (i !== 0) { // 首页不判断 如果页面已存在，则直接定位当页面，否则新增tab页面
          if (this.$refs.tabs[i].name === to.meta.id) {
            this.setCurrentTab(this.$refs.tabs[i].name)
            flag = false
            break
          }
          // }
        }
        // 新增页面
        if (flag) {
          const thisName = to.meta.id
          const thisTitle = to.meta.title
          // vuex添加tab
          this.setTabList({
            title: thisTitle,
            name: thisName,
            closable: true,
            ref: 'tabs'
          })
          this.setCurrentTab(thisName)

          const that = this
          let k = true
          for (let j = 0; j < that.getTabsPath.length; j++) {
            if (that.getTabsPath[j].name === thisName) {
              k = false
              break
            }
          }

          if (k) {
            that.setTabsPath({
              name: thisName,
              path: path,
              params: params
            })
          }
        }
      }
    }
  },
  methods: {
    ...mapMutations('cacheTabs', ['setTabList', 'removeTabList', 'setKeepAliveList', 'removeKeepAliveList', 'setCurrentTab', 'setTabsPath', 'clearTabsPath', 'removeTabsPath']),
    ...mapMutations('pageHeight', ['setMainHeight', 'setSideHeight', 'setContainerHeight', 'setTabHeight', 'setMtableHeight', 'setDtableHeight', 'setMenuWidth']),
    initMainConfig () {
      const that = this
      that.clearTabsPath()
      that.setTabsPath({
        name: that.userHomePage,
        path: '/' + that.userHomePage
      })
      that.setCurrentTab(that.userHomePage)
      that.$router.push({
        path: '/' + that.userHomePage
        // eslint-disable-next-line handle-callback-err
      }).catch(err => {})
    },
    removeTab (targetName) { // 删除Tab
      const tabs = this.cacheTabList // 当前显示的tab数组
      let activeName = this.getCurrentTab // 点前活跃的tab
      // 如果当前tab正活跃 被删除时执行
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            const nextTab = tabs[index + 1] || tabs[index - 1]
            if (nextTab) {
              activeName = nextTab.name
              this.tabClick(nextTab)
            }
          }
        })
      }
      this.setCurrentTab(activeName)
      // this.tabsItem = tabs.filter(tab => tab.name !== targetName)
      this.removeTabList(targetName)
      // 在tabsPath中删除当前被删除tab的path
      this.removeTabsPath(targetName)
      // this.tabsPath = this.tabsPath.filter(item => item.name !== targetName)
    },
    tabClick (thisTab) {
      /*
      * thisTab:当前选中的tabs的实例
      * 通过当前选中tabs的实例获得当前实例的path 重新定位路由
      * */
      const val = this.getTabsPath.filter(item => thisTab.name === item.name)
      this.$router.push({
        path: val[0].path,
        params: val[0].params
        // eslint-disable-next-line handle-callback-err
      }).catch(err => {})
    },
    loadTabFromSession: function () {
      const sessionTabs = JSON.parse(sessionStorage.getItem('tabsItem'))
      if (sessionTabs.currTabsItem.length !== 0 && sessionTabs.currTabsPath.length !== 0) {
        for (let i = 0; i < sessionTabs.currTabsItem.length; i++) {
          this.tabsItem.push({
            title: sessionTabs.currTabsItem[i].title,
            name: sessionTabs.currTabsItem[i].name,
            closable: true,
            ref: sessionTabs.currTabsItem[i].ref,
            content: sessionTabs.currTabsItem[i].content
          })
        }
        for (let j = 0; j < sessionTabs.currTabsPath.length; j++) {
          this.tabsPath.push({
            name: sessionTabs.currTabsPath[j].name,
            path: sessionTabs.currTabsPath[j].path
          })
        }
        this.currentTab = sessionTabs.currActiveTabs
        this.tabIndex = sessionTabs.currIndex
        // 避免强制修改url 出现浏览器的url输入框的路径和当前tabs选中的路由路径不匹配
        const activePath = this.tabsPath.filter(item => item.name === this.currentTab)
        this.$router.push({
          path: activePath[0].path
        })
      }
    },
    tokenCheck: async function () {
      const para = {
        code: this.$Any.getCurrentUser()
      }
      try {
        const { data: res } = await this.$http.post('/users/userCodeCheck', para)
        if (res.data !== '200') {
          this.$router.push('/login')
        }
      } catch (e) {
        this.$router.push('/login')
      }
    }
  },
  mounted () {
    // window.addEventListener('beforeunload', e => {
    //   sessionStorage.setItem('tabsItem', JSON.stringify({
    //     currTabsItem: this.tabsItem.filter(item => item.name !== 'homePage'),
    //     currTabsPath: this.tabsPath.filter(item => item.name !== 'homePage'),
    //     currActiveTabs: this.currentTab,
    //     currIndex: this.tabIndex
    //   }))
    // })
    const that = this
    that.$nextTick(function () {
      const innerHeight = window.innerHeight
      const cHeight = window.innerHeight - 40
      const pHeight = window.innerHeight - 40 - 31
      const mWidth = 200
      that.setMainHeight(innerHeight)
      that.setSideHeight(innerHeight)
      that.setContainerHeight(cHeight)
      that.setMenuWidth(mWidth)
      that.setTabHeight(pHeight)
      // 监听窗口大小变化
      window.onresize = function () {
        const innerHeight = window.innerHeight
        const cHeight = window.innerHeight - 40
        const pHeight = window.innerHeight - 40 - 31
        that.setMainHeight(innerHeight)
        that.setSideHeight(innerHeight)
        that.setContainerHeight(cHeight)
        that.setTabHeight(pHeight)
        that.setMenuWidth(mWidth)
      }
    })

    that.initMainConfig()
  },
  created () {
    const that = this
    that.tokenCheck()
  },
  beforeCreate () {
  }
}
</script>

<style lang="less" scoped>
  .el-header {
    padding: 0;
  }

  .el-main {
    padding: 0;
    height: 100%;
    overflow: hidden;
  }

  /*.el-container {*/
  /*  height: 617px;*/
  /*}*/

  .el-tabs__content {
    /*height: 535px;*/
  }

  .el-tabs {
    height: 100%;
  }

  .el-footer {
    padding: 0;
  }

  .Main{
  }

</style>
